import { SettingsDevicesEapSettingsImportingContainer } from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/settings-devices-eap-settings-importing/settings-devices-eap-settings-importing.container';

export const SettingsDevicesEapSettingsImportingScene = () => <SettingsDevicesEapSettingsImportingContainer />;

export default SettingsDevicesEapSettingsImportingScene;
